<template>
  <div class="mt-6 flex items-center justify-center">
    {{ applicationDetails }}
  </div>
</template>

<script>
import { onMounted, inject, ref } from "vue";
import { useRoute } from "vue-router";
import pdfGenerateHandler from "@/utils/reusables/pdfDecline";
export default {
  setup() {
    const route = useRoute();
    const axios = inject("$axios");
    const router = inject("$router");
    const applicationDetails = ref([]);
    const { exportPDF } = pdfGenerateHandler();
    onMounted(() => {
      let transactionnumber = route.params.id;
      router.push(`/`);
      dataFetchHandler(transactionnumber);
    });

    const dataFetchHandler = async (transactionNumber) => {
      let transactNumber = transactionNumber;
      try {
        const { data } = await axios.get("public/tracking/application", {
          params: { search: transactNumber },
        });

        applicationDetails.value = data;
        exportPDF(data);
      } catch (error) {
        console.log(error);
      }
    };
    return {
      dataFetchHandler,
      applicationDetails,
      exportPDF,
    };
  },
};
</script>
